import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { BehaviorSubject, filter, Observable, shareReplay, switchMap } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { AsyncPipe } from '@angular/common';
import { BoschUiIconNames } from './bosch-ui-icon.constants';

@Component({
  selector: 'bosch-ui-icon',
  standalone: true,
  imports: [AsyncPipe],
  templateUrl: './bosch-ui-icon.component.html',
  styleUrls: ['./bosch-ui-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoschUiIconComponent {
  @Input() set name(iconName: BoschUiIconNames) {
    if (iconName) {
      this.testId = `icon-${iconName}`;
      this._icon$.next(iconName);
    }
  }
  @Input() isButtonIcon = false;
  @Input() width = 24;
  @Input() height: number | null = null;
  @HostBinding('class') get cssClass(): string {
    return `a-icon ${this.isButtonIcon ? 'a-button__icon' : ''}`;
  }

  private _icon$ = new BehaviorSubject<BoschUiIconNames | null>(null);
  testId: string | null = null;
  sanitizedSvgContent$: Observable<SafeHtml> = this._icon$.pipe(
    filter(Boolean),
    switchMap((iconName: BoschUiIconNames) => this.getSvgIcon(iconName)),
  );

  constructor(private http: HttpClient, private sanitizer: DomSanitizer) {}

  getSvgIcon(iconName: string): Observable<SafeHtml> {
    const svgPath = `assets/core/icons/${iconName}.svg`;

    return this.http.get(svgPath, { responseType: 'text' }).pipe(
      map((svg: string) => this.sanitizer.bypassSecurityTrustHtml(svg)),
      shareReplay(1),
    );
  }
}
